<template>  
    <b-modal 
        @hide="OnCancel()"
        v-model="isVisible" 
        size="md" 
        centered 
        hide-footer 
        no-close-on-backdrop 
        no-close-on-esc
        :title="$t('SendCertificate')">
        <b-row>
            <b-col class="d-flex justify-content-center align-items-center">
                <!-- Affichage adresse email -->
                <p class="m-0 pr-3">{{ email }}</p>
                <!-- Bouton d'envoi du mail -->
                <b-button 
                    @click="SendEmail" 
                    pill 
                    :variant="'outline-' + Variant" 
                    v-b-tooltip.html
                    :title="$t('SendMail')">
                    <font-awesome-icon icon="fa-solid fa-envelope-open-text" />
                </b-button>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script lang="ts">
/**
 * Composants vue
 */
import { Vue, Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

/**
 * Classes et énumérations
 */
import { ParticularCustomerInformation } from '@/types/Administration/SMA/CustomerInfo';
import { SMACertificate } from '@/types/Administration/SMA/SMACertificate';

/**
 * Traduction
 */
import locale from '../../locales/SMA.json';

/**
 * Utilitaire
 */
import { SMAUtils } from '../SMAUtils';

@Component({
    i18n: { messages: locale }
})
/**
 * Composant pour l'envoi par mail du mandat à signer.
 * Envoyé à l'adresse mail entrée dans le mandat
 */
export default class SendCertificate extends mixins (Vue, SMAUtils) {
    
    /**
     * Mandat
     */
    @Prop({ default: () => ({}) })
    private Certificate!: SMACertificate;

    /**
     * Variant
     */
    @Prop({ default: 'quartary' })
    private Variant!: string;

    /**
     * Adresse email
     */
    private email: string = '';

    /**
     * Affichage de la fenêtre
     */
    protected isVisible: boolean = true;

    /**
     * Méthode pour l'appel serveur et envoi du mail
     */
    private async SendEmail() {
        this.$store.dispatch("CertificateStore/SendEmail", { item : this.Certificate }).then((data) => 
        {
            this.showToast(data.message, data.success ? "success" : "danger", "SuccessSendEmail");
        })
    }
    
    /**
     * Lors du montage du composant
     * Attribution de la données d'Email présent dans le mandat à la variable 'email'
     */
    private mounted(){
        const customerInfo = this.Certificate.CustomerInfo as ParticularCustomerInformation;
        this.email = customerInfo?.Email ?? '';
    }
    
    /**
     * Lors de l'annulation de l'envoi
     */
    private OnCancel(){
        this.$emit("cancel");
    }
}
</script>

<style scoped>

</style>